import PropTypes from 'prop-types'

import {useEffect} from 'react'

import {trackAddDeputyEvent} from './addDeputyEventLogger'
import Closer from '../../../../../shared_components/core/closer/Closer'
import Modals from '../../../../../shared_components/core/modals/Modals'
import Button from '../../../../../shared_components/mui_base_components/button/Button'

import image from '../../../../../shared_assets/phone-send.svg'

import './deputyAddedConfirmation.scss'

const DeputyAddedConfirmation = ({
  clientFirstName,
  context,
  exit,
  firstName,
  mixpanelContext,
  source = 'planholder'
}) => {
  useEffect(() => {
    trackAddDeputyEvent({
      context: mixpanelContext || context,
      eventName: 'add_deputy_invite_sent',
      payload: {source}
    })
  }, [])

  const headingText = context === 'pro_client_dashboard' ?
    'Your Deputy invite has been saved.' :
    'Your Deputy invitation is on its way!'

  const subheadingText = context === 'pro_client_dashboard' ?
    `${clientFirstName} will receive a reminder to review and send the invite.` :
    `We'll let you know when ${firstName} accepts your invitation.`


  return (
    <Modals.SuccessPopUpModal
      className='deputy-added-confirmation'
      closerComponent={() => <Closer closer={exit} />}
      showModalOnMount>
      <header>
        <img src={image} alt='Success image' />
        <h2>{headingText}</h2>
      </header>
      <div className='subheading'>
        {subheadingText}
      </div>
      {
        context !== 'pro_client_dashboard' &&
        <div className='tip'>
          Tip: Give your Deputy a heads up so the invite doesn't get lost in their inbox.
        </div>
      }
      <Button onClick={exit}>Done</Button>
    </Modals.SuccessPopUpModal>
  )
}

DeputyAddedConfirmation.propTypes = {
  clientFirstName: PropTypes.string,
  context: PropTypes.string,
  exit: PropTypes.func,
  firstName: PropTypes.string,
  mixpanelContext: PropTypes.string,
  source: PropTypes.string
}

export default DeputyAddedConfirmation
